(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9179],{

/***/ 59166:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "U": function() { return /* reexport */ Accordion; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classcat/index.js
var classcat = __webpack_require__(83840);
// EXTERNAL MODULE: ./components/Accordion/accordion.module.sass
var accordion_module = __webpack_require__(38264);
var accordion_module_default = /*#__PURE__*/__webpack_require__.n(accordion_module);
;// CONCATENATED MODULE: ./components/Accordion/Accordion.jsx




var Accordion = function(param) {
    var key = param.key, children = param.children, title = param.title, isOpen = param.isOpen, onCloseExModal = param.onCloseExModal, actionOnClick = param.actionOnClick;
    var ref = (0,react.useState)(isOpen), isActive = ref[0], setIsActive = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (accordion_module_default()).accordion,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "accordion-item",
            itemScope: true,
            itemProp: "mainEntity",
            itemType: "https://schema.org/Question",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                    className: (accordion_module_default()).accordionTitle,
                    onClick: function() {
                        setIsActive(!isActive);
                        if (onCloseExModal) {
                            onCloseExModal();
                        }
                        if (actionOnClick) {
                            actionOnClick();
                        }
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: (accordion_module_default()).innerTitle,
                            itemProp: "name",
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: isActive ? (accordion_module_default()).open : (accordion_module_default()).close
                        }),
                        " "
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (0,classcat/* default */.Z)([
                        (accordion_module_default()).accordionContent,
                        isActive && (accordion_module_default()).accordionContentActive, 
                    ]),
                    itemScope: true,
                    itemProp: "acceptedAnswer",
                    itemType: "https://schema.org/Answer",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        itemProp: "text",
                        children: children
                    })
                })
            ]
        })
    }, key);
};

;// CONCATENATED MODULE: ./components/Accordion/index.js



/***/ }),

/***/ 24277:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "b": function() { return /* reexport */ BreadCrumbs; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classcat/index.js
var classcat = __webpack_require__(83840);
// EXTERNAL MODULE: ./components/BreadCrumbs/breadCrumbs.module.sass
var breadCrumbs_module = __webpack_require__(75685);
var breadCrumbs_module_default = /*#__PURE__*/__webpack_require__.n(breadCrumbs_module);
// EXTERNAL MODULE: ./components/Icon/index.js + 1 modules
var Icon = __webpack_require__(85708);
// EXTERNAL MODULE: ./components/SpriteSVG/index.ts + 1 modules
var SpriteSVG = __webpack_require__(2708);
;// CONCATENATED MODULE: ./components/BreadCrumbs/BreadCrumbs.jsx







var BreadCrumbs = function(param) {
    var routeCrumbs = param.routeCrumbs, url = param.url;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (breadCrumbs_module_default()).wrapper,
        itemScope: true,
        itemType: "https://schema.org/BreadcrumbList",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (breadCrumbs_module_default()).overflowWrapper,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: (breadCrumbs_module_default()).crumb,
                    href: "/",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        itemProp: "name",
                        className: (0,classcat/* default */.Z)([
                            (breadCrumbs_module_default()).home,
                            (0,_define_property/* default */.Z)({}, (breadCrumbs_module_default()).homeBf, url === "black_friday"), 
                        ]),
                        children: url === "black_friday" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SpriteSVG/* IconSVG */.u, {
                                name: "common/bfHomePage",
                                width: 10,
                                height: 10
                            }),
                            itemProp: "item"
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SpriteSVG/* IconSVG */.u, {
                                name: "common/HomePage",
                                width: 16,
                                height: 16
                            }),
                            itemProp: "item"
                        })
                    })
                }),
                routeCrumbs.map(function(i, id) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        itemProp: "itemListElement",
                        itemScope: true,
                        itemType: "https://schema.org/ListItem",
                        className: (breadCrumbs_module_default()).point,
                        children: url === "black_friday" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            itemProp: "item",
                            href: i.link,
                            className: (breadCrumbs_module_default()).crumb,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    itemProp: "name",
                                    className: id === routeCrumbs.length - 1 ? (breadCrumbs_module_default()).currentBf : (breadCrumbs_module_default()).activeBf,
                                    children: i.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                    itemProp: "position",
                                    content: id + 1
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            itemProp: "item",
                            href: i.link,
                            className: (breadCrumbs_module_default()).crumb,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    itemProp: "name",
                                    className: id === routeCrumbs.length - 1 ? (breadCrumbs_module_default()).current : (breadCrumbs_module_default()).active,
                                    children: i.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                    itemProp: "position",
                                    content: id + 1
                                })
                            ]
                        })
                    }, id);
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/BreadCrumbs/index.js



/***/ }),

/***/ 63145:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "H": function() { return /* reexport */ Collapsed; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/interweave/esm/index.js
var esm = __webpack_require__(63108);
// EXTERNAL MODULE: ./components/Accordion/index.js + 1 modules
var Accordion = __webpack_require__(59166);
// EXTERNAL MODULE: ./components/Button/index.js + 1 modules
var Button = __webpack_require__(11866);
// EXTERNAL MODULE: ./lib/YaAndGaHelper.js + 2 modules
var YaAndGaHelper = __webpack_require__(38214);
;// CONCATENATED MODULE: ./components/Collapsed/Collapsed.jsx









/**
 * Компонент для скрытия контента
 * Переписать на нормальный компонент
 */ var Collapsed = function(_param) {
    var items = _param.items, isOpen = _param.isOpen, shorter = _param.shorter, isResult = _param.isResult, isCruis = _param.isCruis, isSeo = _param.isSeo, seo = _param.seo, isPickCaute = _param.isPickCaute, onCloseExModal = _param.onCloseExModal, onClickAction = _param.onClickAction, targets = _param.targets, props = (0,_object_without_properties/* default */.Z)(_param, [
        "items",
        "isOpen",
        "shorter",
        "isResult",
        "isCruis",
        "isSeo",
        "seo",
        "isPickCaute",
        "onCloseExModal",
        "onClickAction",
        "targets"
    ]);
    var ref;
    var ref1 = (0,react.useState)(3), count = ref1[0], setCount = ref1[1];
    var ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            isSeo && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: seo.map(function(param) {
                    var title = param.title, description = param.description;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* Accordion */.U, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        isOpen: isOpen,
                        title: title
                    }, props), {
                        children: description
                    }));
                })
            }),
            isResult ? items === null || items === void 0 ? void 0 : items.map(function(i) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* Accordion */.U, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    isOpen: isOpen,
                    title: i.title
                }, props), {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* default */.ZP, {
                        content: "".concat(i.body.text)
                    })
                }), i.title);
            }).slice(0, shorter ? count : items.length) : (ref2 = (ref = items === null || items === void 0 ? void 0 : items.slice(0, shorter ? count : items.length)) === null || ref === void 0 ? void 0 : ref.map(function(i) {
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(Accordion/* Accordion */.U, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    isOpen: isOpen,
                    title: isSeo ? i === null || i === void 0 ? void 0 : i.caption : i === null || i === void 0 ? void 0 : i.title,
                    onCloseExModal: onCloseExModal,
                    actionOnClick: function() {
                        if (i.target) {
                            (0,YaAndGaHelper/* YaAndGaCruisePage */.uX)([
                                i.target
                            ]);
                        }
                    }
                }, props), {
                    children: !isCruis ? /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* default */.ZP, {
                        content: "".concat(!isPickCaute ? i.body : i === null || i === void 0 ? void 0 : i.desc)
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: i.body
                    })
                }), i === null || i === void 0 ? void 0 : i.title);
            })) !== null && ref2 !== void 0 ? ref2 : [].slice(0, shorter ? count : items.length),
            shorter && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: count < (items === null || items === void 0 ? void 0 : items.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                    onClick: function() {
                        setCount(count + 3);
                        (0,YaAndGaHelper/* YaAndGaCruisePage */.uX)(onClickAction);
                    },
                    children: "Загрузить ещё вопросы"
                })
            })
        ]
    });
};
Collapsed.defaultProps = {
    isOpen: false,
    shorter: false
};

;// CONCATENATED MODULE: ./components/Collapsed/index.js



/***/ }),

/***/ 178:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* reexport safe */ _Modal__WEBPACK_IMPORTED_MODULE_0__.u; }
/* harmony export */ });
/* harmony import */ var _Modal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31735);



/***/ }),

/***/ 94925:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "c": function() { return /* reexport */ EmptySearch; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/SearchCruises/EmptySearch/emptySearch.module.sass
var emptySearch_module = __webpack_require__(75949);
var emptySearch_module_default = /*#__PURE__*/__webpack_require__.n(emptySearch_module);
// EXTERNAL MODULE: ./components/Text/index.js + 1 modules
var Text = __webpack_require__(82372);
// EXTERNAL MODULE: ./components/Icon/index.js + 1 modules
var Icon = __webpack_require__(85708);
// EXTERNAL MODULE: ./components/SpriteSVG/index.ts + 1 modules
var SpriteSVG = __webpack_require__(2708);
;// CONCATENATED MODULE: ./components/SearchCruises/EmptySearch/EmptySearch.jsx






var EmptySearch = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (emptySearch_module_default()).emptySearch,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (emptySearch_module_default()).emptySearchIcon,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SpriteSVG/* IconSVG */.u, {
                            name: "common/EmptyDate",
                            width: 48,
                            height: 48
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (emptySearch_module_default()).emptySearchDescription,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                        variant: "heading-8",
                        children: "По выбранным параметрам отправлений нет, попробуйте изменить фильтр или дату."
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/SearchCruises/EmptySearch/index.js



/***/ }),

/***/ 21831:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "G": function() { return /* reexport */ ShipsPage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/use-media/lib/index.js
var lib = __webpack_require__(30587);
// EXTERNAL MODULE: ./components/Text/index.js + 1 modules
var Text = __webpack_require__(82372);
// EXTERNAL MODULE: ./components/ShipsPage/shipsPage.module.sass
var shipsPage_module = __webpack_require__(17766);
var shipsPage_module_default = /*#__PURE__*/__webpack_require__.n(shipsPage_module);
// EXTERNAL MODULE: ./utils/isClient.js
var isClient = __webpack_require__(69594);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
;// CONCATENATED MODULE: ./node_modules/react-use/esm/useFirstMountState.js

function useFirstMountState() {
    var isFirst = (0,react.useRef)(true);
    if (isFirst.current) {
        isFirst.current = false;
        return true;
    }
    return isFirst.current;
}

// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82580);
// EXTERNAL MODULE: ./node_modules/mobx-react-lite/es/index.js + 13 modules
var es = __webpack_require__(46670);
// EXTERNAL MODULE: ./components/SortPopup/index.js + 1 modules
var SortPopup = __webpack_require__(46902);
// EXTERNAL MODULE: ./providers/RootStoreProvider.jsx + 49 modules
var RootStoreProvider = __webpack_require__(8710);
// EXTERNAL MODULE: ./components/Button/index.js + 1 modules
var Button = __webpack_require__(11866);
// EXTERNAL MODULE: ./components/Modal/index.js
var Modal = __webpack_require__(178);
// EXTERNAL MODULE: ./components/ShipsPage/ShipSearchResults/components/ShipCardList/shipCardList.module.sass
var shipCardList_module = __webpack_require__(19079);
var shipCardList_module_default = /*#__PURE__*/__webpack_require__.n(shipCardList_module);
// EXTERNAL MODULE: ./components/Skeleton/index.js + 1 modules
var Skeleton = __webpack_require__(61273);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/classcat/index.js
var classcat = __webpack_require__(83840);
// EXTERNAL MODULE: ./components/ShipsPage/ShipSearchResults/components/ShipCard/shipCard.module.sass
var shipCard_module = __webpack_require__(74249);
var shipCard_module_default = /*#__PURE__*/__webpack_require__.n(shipCard_module);
// EXTERNAL MODULE: ./components/Icon/index.js + 1 modules
var Icon = __webpack_require__(85708);
// EXTERNAL MODULE: ./components/Badge/index.js + 1 modules
var Badge = __webpack_require__(92558);
// EXTERNAL MODULE: ./utils/declOfNum.js
var declOfNum = __webpack_require__(5547);
// EXTERNAL MODULE: ./components/SpriteSVG/index.ts + 1 modules
var SpriteSVG = __webpack_require__(2708);
// EXTERNAL MODULE: ./lib/yandexDataLayer.js
var yandexDataLayer = __webpack_require__(12406);
;// CONCATENATED MODULE: ./components/ShipsPage/ShipSearchResults/components/ShipCard/ShipCard.jsx












var categories = {
    1: {
        classCategoryReady: "eco",
        title: "Эконом"
    },
    2: {
        classCategoryReady: "standart",
        title: "Стандарт"
    },
    3: {
        classCategoryReady: "comfort",
        title: "Комфорт"
    },
    6: {
        classCategoryReady: "lux",
        title: "Люкс"
    },
    7: {
        classCategoryReady: "premium",
        title: "Премиум"
    }
};
var ShipCard = (0,es/* observer */.Pi)(function(param) {
    var shipInfo = param.shipInfo, position = param.position, _title = param.title, title = _title === void 0 ? "" : _title, url = param.url, places = param.places, category = param.category, viewed = param.viewed, image = param.image, countDesc = param.countDesc, peoples_count = param.peoples_count, cauta_count = param.cauta_count, construction_date = param.construction_date, restoration_date = param.restoration_date, type = param.type, isMobile = param.isMobile;
    var ref, ref1;
    var href = "/ships/".concat(url);
    var isSea = type === "sea";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (shipCard_module_default()).wrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                    className: (shipCard_module_default()).main,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                            className: (shipCard_module_default()).header,
                            children: title || "-"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (shipCard_module_default()).pic,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: href,
                                    style: {
                                        display: "flex",
                                        height: "100%"
                                    },
                                    className: (0,classcat/* default */.Z)((0,_define_property/* default */.Z)({}, (shipCard_module_default()).blackout, viewed)),
                                    rel: "nofollow noreferrer",
                                    onClick: function() {
                                        (0,yandexDataLayer/* yandexDataLayer */.qu)("click", {
                                            id: shipInfo.id,
                                            name: shipInfo.name,
                                            brand: shipInfo.company || "",
                                            category: shipInfo.class.lable,
                                            position: position + 1,
                                            quantity: 1
                                        });
                                    },
                                    children: image && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "/".concat(image),
                                        alt: "Теплоход ".concat(title),
                                        title: "Теплоход ".concat(title),
                                        loading: "lazy"
                                    }) || /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SpriteSVG/* IconSVG */.u, {
                                            name: "common/ships-plug",
                                            width: 400,
                                            height: 172,
                                            alt: title
                                        }),
                                        alt: title,
                                        loading: "lazy"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (shipCard_module_default()).badges,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* Badge */.C, {
                                            size: "smUltra",
                                            view: (ref = categories[category.value]) === null || ref === void 0 ? void 0 : ref.classCategoryReady,
                                            icon: (ref1 = categories[category.value]) === null || ref1 === void 0 ? void 0 : ref1.classCategoryReady,
                                            children: category.lable
                                        }),
                                        places > 0 && places < 25 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* Badge */.C, {
                                            view: "hot",
                                            size: "smUltra",
                                            icon: "fire",
                                            children: "Осталось ".concat(places, "\n                    ").concat((0,declOfNum/* declOfNum */.A)(places, [
                                                "каюта",
                                                "каюты",
                                                "кают"
                                            ]))
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Badge/* Badge */.C, {
                                            view: "luxSolid",
                                            size: "smUltra",
                                            children: [
                                                countDesc,
                                                " ",
                                                (0,declOfNum/* declOfNum */.A)(countDesc, [
                                                    "палуба",
                                                    "палубы",
                                                    "палуб"
                                                ])
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (shipCard_module_default()).body,
                            children: [
                                restoration_date !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (shipCard_module_default()).year,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: "Реновация ".concat(restoration_date, " ")
                                        }),
                                        "Год постройки ".concat(construction_date)
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (shipCard_module_default()).bonus,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SpriteSVG/* IconSVG */.u, {
                                                name: "promo/caute_count",
                                                width: 24,
                                                height: 24
                                            }),
                                            rightGap: 8,
                                            title: "Иконка кэшбека"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            children: [
                                                "Общее количество кают: ",
                                                cauta_count
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (shipCard_module_default()).bonus,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SpriteSVG/* IconSVG */.u, {
                                                name: "promo/seat_count",
                                                width: 24,
                                                height: 24
                                            }),
                                            rightGap: 8,
                                            title: "Иконка кэшбека"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            children: [
                                                "Вместимость (человек): ",
                                                peoples_count
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("footer", {
                className: (shipCard_module_default()).footer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Anchor */.e, {
                        decoration: "none",
                        className: (shipCard_module_default()).shipButton,
                        href: "/ships/".concat(url),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (shipCard_module_default()).btn,
                            children: "Подробнее о корабле и круизах"
                        })
                    }),
                    !isSea && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Anchor */.e, {
                        decoration: "none",
                        variant: "linkAsbuttonCashback",
                        className: (shipCard_module_default()).shipButton,
                        href: "/rent",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (shipCard_module_default()).btnRent,
                            children: "Аренда корабля"
                        })
                    })
                ]
            })
        ]
    });
});

;// CONCATENATED MODULE: ./components/ShipsPage/ShipSearchResults/components/ShipCard/index.js


;// CONCATENATED MODULE: ./components/ShipsPage/ShipSearchResults/components/ShipCardList/ShipCardList.jsx





// Enum для типов круиза
var CruiseType = {
    Rivers: "rivers",
    Sea: "sea"
};
var ShipCardList = function(param) {
    var cruises = param.cruises, type = param.type, isMobile = param.isMobile, isLoading = param.isLoading;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: !isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (shipCardList_module_default()).cardList,
            children: cruises === null || cruises === void 0 ? void 0 : cruises.map(function(i, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ShipCard, {
                    position: index,
                    shipInfo: i,
                    title: i.name,
                    type: type,
                    url: i.url,
                    countDesc: i.deck_count,
                    cauta_count: i.cauta_count,
                    seat_count: i.seat_of_the_ship,
                    peoples_count: i.peoples_count,
                    construction_date: i.construction_date,
                    restoration_date: i.restoration_date,
                    link: i.id,
                    category: i.class,
                    image: i.img,
                    isMobile: isMobile
                }, i.id);
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (shipCardList_module_default()).cardList,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* SkeletonCard */.A, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* SkeletonCard */.A, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* SkeletonCard */.A, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* SkeletonCard */.A, {})
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/ShipsPage/ShipSearchResults/components/ShipCardList/index.js


;// CONCATENATED MODULE: ./components/ShipsPage/ShipSearchResults/components/ShowMore/ShowMore.jsx



var ShowMore = function(param) {
    var length = param.length, amount = param.amount, setPage = param.setPage;
    var isShowButton = function(lengthCard, amountCard) {
        return lengthCard > amountCard;
    };
    return isShowButton(length, amount) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
        view: "textResult",
        onClick: function() {
            setPage();
        },
        fullWidth: true,
        topGap: true,
        children: "ПОКАЗАТЬ ЕЩЕ"
    });
};

;// CONCATENATED MODULE: ./components/ShipsPage/ShipSearchResults/components/ShowMore/index.js


// EXTERNAL MODULE: ./components/ShipsPage/ShipSearchResults/components/ShipMobileResult/shipMobileResult.module.sass
var shipMobileResult_module = __webpack_require__(99590);
var shipMobileResult_module_default = /*#__PURE__*/__webpack_require__.n(shipMobileResult_module);
// EXTERNAL MODULE: ./components/Skeleton/SkeletonCover.jsx
var SkeletonCover = __webpack_require__(9792);
// EXTERNAL MODULE: ./components/SearchCruises/EmptySearch/index.js + 1 modules
var EmptySearch = __webpack_require__(94925);
;// CONCATENATED MODULE: ./resources/sortShips.js
var sortShips = [
    {
        title: "По реновации",
        mode: "restoration_date",
        type: "DESC"
    },
    {
        title: "По году постройки",
        mode: "construction_date",
        type: "DESC"
    }, 
];

// EXTERNAL MODULE: ./components/Checkbox/index.js + 1 modules
var Checkbox = __webpack_require__(75538);
// EXTERNAL MODULE: ./components/ShipsPage/ShipSearchResults/components/ShipFilterCheckboxes/shipFilterCheckboxes.module.sass
var shipFilterCheckboxes_module = __webpack_require__(8978);
var shipFilterCheckboxes_module_default = /*#__PURE__*/__webpack_require__.n(shipFilterCheckboxes_module);
;// CONCATENATED MODULE: ./components/ShipsPage/ShipSearchResults/components/ShipFilterCheckboxes/ShipFilterCheckboxes.jsx






var ShipFilterCheckboxes = function(param) {
    var name = param.name, items = param.items, title = param.title, isLoading = param.isLoading, onShowMore = param.onShowMore, isOpen = param.isOpen;
    var setFieldValue = (0,formik_esm/* useFormikContext */.u6)().setFieldValue;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
                className: (shipFilterCheckboxes_module_default()).header,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (shipFilterCheckboxes_module_default()).title,
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        view: "text",
                        onClick: function() {
                            return setFieldValue(name, []);
                        },
                        children: "Очистить"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                className: (shipFilterCheckboxes_module_default()).body,
                children: !!items.length && items.map(function(param, index) {
                    var lable = param.lable, value = param.value, _checked = param.checked, checked = _checked === void 0 ? false : _checked, count = param.count;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (shipFilterCheckboxes_module_default()).item,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* Checkbox */.X, {
                                size: "sm",
                                name: name,
                                value: value,
                                checked: checked,
                                disabled: isLoading,
                                children: lable
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (shipFilterCheckboxes_module_default()).info,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (shipFilterCheckboxes_module_default()).count,
                                    children: count
                                })
                            })
                        ]
                    }, index);
                })
            }),
            onShowMore && /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
                className: (shipFilterCheckboxes_module_default()).footer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                    view: "text",
                    onClick: onShowMore,
                    children: isOpen ? "Скрыть" : "Показать еще"
                })
            })
        ]
    });
};
ShipFilterCheckboxes.defaultProps = {
    items: []
};

;// CONCATENATED MODULE: ./components/ShipsPage/ShipSearchResults/components/ShipFilterCheckboxes/index.js


;// CONCATENATED MODULE: ./components/ShipsPage/ShipSearchResults/components/ShipMobileResult/ShipMobileResult.jsx






// import {useRouter} from 'next/router';





// import {FilterCheckboxes} from '../../../../FilterCheckboxes';






// import {sorts} from '../../../../../resources/sorts';






var AutoSubmitForm = (0,es/* observer */.Pi)(function() {
    var ref;
    var store = (0,RootStoreProvider/* useShipsSearchStore */.rm)();
    var setBottomFilters = function(filters) {
        return store.setBottomFilters(filters);
    };
    // const clearFilters = () => store.clearFilters();
    var ref1 = (0,formik_esm/* useFormikContext */.u6)(), values = ref1.values, submitForm = ref1.submitForm, setFieldValue = ref1.setFieldValue;
    var isFirstMount = useFirstMountState();
    (0,react.useEffect)(function() {
        if (!isFirstMount) {
            setBottomFilters(values);
            submitForm();
        }
    }, [
        values,
        submitForm
    ]);
    (0,react.useEffect)(function() {
        if (!isFirstMount) {
            setBottomFilters(values);
            submitForm();
        }
    }, [
        values,
        submitForm
    ]);
    (0,react.useEffect)(function() {
        setFieldValue("filterClasses", []);
        setFieldValue("filterServices", []);
    }, [
        (ref = store.filters) === null || ref === void 0 ? void 0 : ref.type
    ]);
    return null;
});
var COUNT_SHIPS = 10;
var ShipMobileResult = (0,es/* observer */.Pi)(function(param) {
    var isMobile = param.isMobile;
    // const router = useRouter();
    // const [isTypeShipOpen, setTypeShipOpen] = useState(false);
    var ref = (0,react.useState)(false), isMobileFiltersOpen = ref[0], setIsMobileFiltersOpen = ref[1];
    // const store = useSearchStore();
    // const getList = () => store.getList();
    // const setParamsFilters = params => store.setParamsFilters(params);
    // const setPage = () => store.setPage();
    // const { amount } = store;
    // const { type } = router.query;
    var btn = react.useRef();
    var store = (0,RootStoreProvider/* useShipsSearchStore */.rm)();
    var isLoading = store.isLoading, filterClasses = store.filterClasses, filterServices = store.filterServices, filteredShips = store.filteredShips, shipsList = store.shipsList, filters = store.filters;
    // const getList = () => store.getList();
    var setParamsFilters = store.setParamsFilters;
    // const clearFilters = () => store.clearFilters();
    // const setExtraShips = params => store.setExtraShips(params);
    // const setPage = () => store.setPage();
    var ref1 = (0,react.useState)(false), isTypeShipOpen = ref1[0], setTypeShipOpen = ref1[1];
    var ref2 = (0,react.useState)(COUNT_SHIPS), countShips = ref2[0], setCountShips = ref2[1];
    var showMore = function() {
        setCountShips(countShips + COUNT_SHIPS);
    };
    (0,react.useEffect)(function() {
        store.getInitialData();
    }, []);
    var ships = filteredShips.slice(0, countShips);
    // скрытие фильтров при скроле вниз
    // let oldScrollY = 0;
    // const defaultOffset = 400;
    //
    // const scrollPosition = () =>
    //   window.pageYOffset || document.documentElement.scrollTop;
    // const containHide = () => btn.current.classList.contains(styles.hide);
    //
    // if (isClient) {
    //   window.addEventListener('scroll', () => {
    //     if (
    //       scrollPosition() > oldScrollY &&
    //       !containHide() &&
    //       scrollPosition() > defaultOffset
    //     ) {
    //       btn.current.classList.add(styles.hide);
    //     } else if (scrollPosition() < oldScrollY && containHide()) {
    //       btn.current.classList.remove(styles.hide);
    //     }
    //     oldScrollY = scrollPosition();
    //   });
    // }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
        initialValues: {
            filterClasses: [],
            filterServices: [],
            sort: {
                sort_mode: sortShips[0].mode,
                sort_direction: sortShips[0].type
            }
        },
        onSubmit: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(values) {
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            setParamsFilters(values);
                        case 1:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(values) {
                return _ref.apply(this, arguments);
            };
        }(),
        children: function(param) {
            var values = param.values;
            var services = filterServices.map(function(service) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, service), {
                    count: shipsList.filter(function(ship) {
                        var ref;
                        return (ref = ship.services) === null || ref === void 0 ? void 0 : ref.some(function(service1) {
                            return service1.value === service.value;
                        });
                    }).length
                });
            }).slice(0, isTypeShipOpen ? filterServices.length : 5);
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoSubmitForm, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (shipMobileResult_module_default()).header,
                        children: [
                            !store.useFirstLoad ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (shipMobileResult_module_default()).total,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "Всего теплоходов:"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* Badge */.C, {
                                        view: "info",
                                        size: "smUltra",
                                        children: filteredShips.length
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonCover/* SkeletonCover */.B, {
                                    width: 200,
                                    height: 30
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SortPopup/* SortPopup */.T, {
                                id: "sort",
                                sorts: sortShips,
                                active: values.sort
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "container container--start",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* Modal */.u, {
                            title: "Фильтр",
                            size: "sm",
                            isOpen: isMobileFiltersOpen,
                            onOpen: setIsMobileFiltersOpen,
                            actions: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                view: "text",
                                onClick: function() {
                                    return setIsMobileFiltersOpen();
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SpriteSVG/* IconSVG */.u, {
                                    name: "common/close",
                                    width: 16,
                                    height: 16
                                })
                            }),
                            fullScreen: true,
                            hideCross: true,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ShipFilterCheckboxes, {
                                    name: "filterClasses",
                                    title: "Теплоходы",
                                    isLoading: isLoading,
                                    items: filterClasses.map(function(classItem) {
                                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, classItem), {
                                            count: shipsList.filter(function(ship) {
                                                return ship.class.value === classItem.value;
                                            }).length
                                        });
                                    }),
                                    ships: shipsList.map(function(ship) {
                                        return ship.class;
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ShipFilterCheckboxes, {
                                    name: "filterServices",
                                    title: "Услуги на борту",
                                    isLoading: isLoading,
                                    items: services,
                                    onShowMore: services.length === filterServices.length ? function() {
                                        return setTypeShipOpen(false);
                                    } : function() {
                                        return setTypeShipOpen(true);
                                    },
                                    isOpen: isTypeShipOpen
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                    className: (shipMobileResult_module_default()).buttonWrapper,
                                    background: "primary",
                                    size: "semi-lg",
                                    onClick: function() {
                                        return [
                                            setIsMobileFiltersOpen(false)
                                        ];
                                    },
                                    fullWidth: true,
                                    children: "Показать теплоходы"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (shipMobileResult_module_default()).wrapper,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: (ships === null || ships === void 0 ? void 0 : ships.length) === 0 && !isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptySearch/* EmptySearch */.c, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ShipCardList, {
                                            isLoading: isLoading,
                                            cruises: ships,
                                            type: filters === null || filters === void 0 ? void 0 : filters.type,
                                            isMobile: isMobile
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ShowMore, {
                                            length: filteredShips === null || filteredShips === void 0 ? void 0 : filteredShips.length,
                                            amount: countShips,
                                            setPage: showMore
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (shipMobileResult_module_default()).applyFilter,
                                ref: btn,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* Button */.z, {
                                    view: "text",
                                    onClick: function() {
                                        return setIsMobileFiltersOpen(true);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (shipMobileResult_module_default()).applyFilterMargin,
                                            children: values.filterClasses.length === 0 && values.filterServices.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SpriteSVG/* IconSVG */.u, {
                                                    name: "common/filter",
                                                    width: 17,
                                                    height: 17
                                                })
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SpriteSVG/* IconSVG */.u, {
                                                    name: "common/filterRedDot",
                                                    width: 23,
                                                    height: 21
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: "Показать фильтры"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            });
        }
    });
});

;// CONCATENATED MODULE: ./components/ShipsPage/ShipSearchResults/components/ShipMobileResult/index.js


// EXTERNAL MODULE: ./components/ShipsPage/ShipSearchResults/components/ShipDesktopResult/shipDesktopResult.module.sass
var shipDesktopResult_module = __webpack_require__(54972);
var shipDesktopResult_module_default = /*#__PURE__*/__webpack_require__.n(shipDesktopResult_module);
;// CONCATENATED MODULE: ./components/ShipsPage/ShipSearchResults/components/ShipDesktopResult/ShipDesktopResult.jsx























var ShipDesktopResult_AutoSubmitForm = (0,es/* observer */.Pi)(function() {
    var store = (0,RootStoreProvider/* useShipsSearchStore */.rm)();
    var setBottomFilters = function(filters) {
        return store.setBottomFilters(filters);
    };
    // const clearFilters = () => store.clearFilters();
    var ref = (0,formik_esm/* useFormikContext */.u6)(), values = ref.values, submitForm = ref.submitForm;
    var isFirstMount = useFirstMountState();
    (0,react.useEffect)(function() {
        if (!isFirstMount) {
            setBottomFilters(values);
            submitForm();
        }
    }, [
        values,
        submitForm
    ]);
    return null;
});
var ShipDesktopResult_COUNT_SHIPS = 10;
var ShipDesktopResult = (0,es/* observer */.Pi)(function(param) {
    var liners = param.liners, isMobile = param.isMobile;
    var store = (0,RootStoreProvider/* useShipsSearchStore */.rm)();
    var isLoading = store.isLoading, filterClasses = store.filterClasses, filterServices = store.filterServices, filteredShips = store.filteredShips, shipsList = store.shipsList, filters = store.filters;
    // const getList = () => store.getList();
    var setParamsFilters = store.setParamsFilters;
    var clearFilters = function() {
        return store.clearFilters();
    };
    // const setExtraShips = params => store.setExtraShips(params);
    // const setPage = () => store.setPage();
    var ref = (0,react.useState)(false), isTypeShipOpen = ref[0], setTypeShipOpen = ref[1];
    var ref1 = (0,react.useState)(ShipDesktopResult_COUNT_SHIPS), countShips = ref1[0], setCountShips = ref1[1];
    var showMore = function() {
        setCountShips(countShips + ShipDesktopResult_COUNT_SHIPS);
    };
    (0,react.useEffect)(function() {
        store.getInitialData();
    }, []);
    var ships = filteredShips.slice(0, countShips);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
        initialValues: {
            filterClasses: [],
            filterServices: [],
            sort: {
                sort_mode: sortShips[0].mode,
                sort_direction: sortShips[0].type
            }
        },
        onSubmit: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(values) {
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            setParamsFilters(values);
                        case 1:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(values) {
                return _ref.apply(this, arguments);
            };
        }(),
        children: function(param) {
            var values = param.values, setFieldValue = param.setFieldValue;
            var services = filterServices.map(function(service) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, service), {
                    count: shipsList.filter(function(ship) {
                        var ref;
                        return (ref = ship.services) === null || ref === void 0 ? void 0 : ref.some(function(service1) {
                            return service1.value === service.value;
                        });
                    }).length
                });
            }).slice(0, isTypeShipOpen ? filterServices.length : 5);
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ShipDesktopResult_AutoSubmitForm, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (shipDesktopResult_module_default()).header,
                        children: [
                            !store.useFirstLoad ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (shipDesktopResult_module_default()).total,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        children: [
                                            liners ? "Всего лайнеров" : "Всего теплоходов",
                                            ":"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* Badge */.C, {
                                        view: "info",
                                        size: "smUltra",
                                        children: filteredShips.length
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonCover/* SkeletonCover */.B, {
                                    width: 200,
                                    height: 30
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SortPopup/* SortPopup */.T, {
                                id: "sort",
                                sorts: sortShips,
                                active: values.sort
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (shipDesktopResult_module_default()).wrapper,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (0,classcat/* default */.Z)([
                                    (shipDesktopResult_module_default()).sidebar,
                                    (0,_define_property/* default */.Z)({}, (shipDesktopResult_module_default()).sidebarOpen, isTypeShipOpen), 
                                ]),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (shipDesktopResult_module_default()).sidebarTop,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (shipDesktopResult_module_default()).sidebarTitle,
                                                children: "Фильтр"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                                view: "text",
                                                onClick: function() {
                                                    clearFilters();
                                                    setFieldValue("filterClasses", []);
                                                    setFieldValue("filterServices", []);
                                                },
                                                children: "Очистить всё"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ShipFilterCheckboxes, {
                                        name: "filterClasses",
                                        title: liners ? "Лайнеров" : "Теплоход",
                                        isLoading: isLoading,
                                        items: filterClasses.map(function(classItem) {
                                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, classItem), {
                                                count: shipsList.filter(function(ship) {
                                                    return ship.class.value === classItem.value;
                                                }).length
                                            });
                                        }),
                                        ships: shipsList.map(function(ship) {
                                            return ship.class;
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ShipFilterCheckboxes, {
                                        name: "filterServices",
                                        title: "Услуги на борту",
                                        isLoading: isLoading,
                                        items: services,
                                        onShowMore: filterServices.length <= 5 ? undefined : function() {
                                            return setTypeShipOpen(services.length !== filterServices.length);
                                        },
                                        isOpen: isTypeShipOpen
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (shipDesktopResult_module_default()).list,
                                children: (ships === null || ships === void 0 ? void 0 : ships.length) === 0 && !isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptySearch/* EmptySearch */.c, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ShipCardList, {
                                            isLoading: isLoading,
                                            cruises: ships,
                                            type: filters === null || filters === void 0 ? void 0 : filters.type,
                                            isMobile: isMobile
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ShowMore, {
                                            length: filteredShips === null || filteredShips === void 0 ? void 0 : filteredShips.length,
                                            amount: countShips,
                                            setPage: showMore
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            });
        }
    });
});

;// CONCATENATED MODULE: ./components/ShipsPage/ShipSearchResults/components/ShipDesktopResult/index.js


;// CONCATENATED MODULE: ./components/ShipsPage/ShipSearchResults/ShipSearchResults.jsx




var ShipSearchResults = function(param) {
    var isMobile = param.isMobile, liners = param.liners;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ShipMobileResult, {
            liners: liners,
            isMobile: isMobile
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ShipDesktopResult, {
            liners: liners,
            isMobile: isMobile
        })
    });
};

;// CONCATENATED MODULE: ./components/ShipsPage/ShipSearchResults/index.js


// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./components/ShipsPage/ShipsSearch/shipsSearch.module.sass
var shipsSearch_module = __webpack_require__(50172);
var shipsSearch_module_default = /*#__PURE__*/__webpack_require__.n(shipsSearch_module);
// EXTERNAL MODULE: ./components/DropDown/index.js + 1 modules
var DropDown = __webpack_require__(25071);
// EXTERNAL MODULE: ./components/ShipsPage/ShipsSearch/components/SearchShips/searchShips.module.sass
var searchShips_module = __webpack_require__(78141);
var searchShips_module_default = /*#__PURE__*/__webpack_require__.n(searchShips_module);
// EXTERNAL MODULE: ./components/SearchInput/index.js + 1 modules
var SearchInput = __webpack_require__(44745);
// EXTERNAL MODULE: ./components/DropDown/components/CheckboxList/index.js + 1 modules
var CheckboxList = __webpack_require__(71418);
// EXTERNAL MODULE: ./lib/YaAndGaHelper.js + 2 modules
var YaAndGaHelper = __webpack_require__(38214);
;// CONCATENATED MODULE: ./components/ShipsPage/ShipsSearch/components/SearchShips/SearchShips.jsx









var citiesToString = function(arr) {
    if (!arr.length) return "";
    var str = arr.join(", ");
    var limit = 30;
    if (str.length > limit) {
        return "".concat(str.slice(0, limit), "...");
    }
    return str;
};
var SearchShips = function(_param) {
    var val = _param.value, id = _param.id, placeholder = _param.placeholder, label = _param.label, error = _param.error, _ships = _param.ships, ships = _ships === void 0 ? [] : _ships, actions = _param.actions, isBodyRight = _param.isBodyRight, disabled = _param.disabled, view = _param.view, firstLoading = _param.firstLoading, onClickField = _param.onClickField, onClearButtonClick = _param.onClearButtonClick, searchLabel = _param.searchLabel, props = (0,_object_without_properties/* default */.Z)(_param, [
        "value",
        "id",
        "placeholder",
        "label",
        "error",
        "ships",
        "actions",
        "isBodyRight",
        "disabled",
        "view",
        "firstLoading",
        "onClickField",
        "onClearButtonClick",
        "searchLabel"
    ]);
    var ref = (0,react.useState)(""), search = ref[0], setSearch = ref[1];
    var filterCities = function() {
        var arr = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], str = arguments.length > 1 ? arguments[1] : void 0;
        return arr.filter(function(i) {
            return i.toLowerCase().includes(str.toLowerCase());
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DropDown/* DropDown */.v, (0,_object_spread/* default */.Z)({
        firstLoading: firstLoading,
        value: citiesToString(val),
        id: id,
        placeholder: placeholder,
        label: label,
        error: error,
        isBodyRight: isBodyRight,
        view: view,
        onClickField: function() {
            var // console.log('zalupa', id);
            ref;
            onClickField === null || onClickField === void 0 ? void 0 : onClickField();
            var eventMap = {
                selectedShips: function() {
                    return (0,YaAndGaHelper/* YaAndGaShipPage */.tj)("click_ship_search_line");
                },
                departure: function() {
                    return (0,YaAndGaHelper/* YaAndGaSearchLine */.Fm)("click_field_search_city_departure");
                },
                arrival: function() {
                    return (0,YaAndGaHelper/* YaAndGaSearchLine */.Fm)("click_field_search_city_arrival");
                }
            };
            (ref = eventMap[id]) === null || ref === void 0 ? void 0 : ref.call(eventMap);
        },
        onClearButtonClick: onClearButtonClick,
        content: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                actions && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (searchShips_module_default()).searchCityActions,
                    children: actions
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchInput/* SearchInput */.M, {
                    placeholder: searchLabel,
                    onChange: function(e) {
                        return setSearch(e.target.value);
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckboxList/* CheckboxList */.s, {
                    items: filterCities(ships, search),
                    name: id,
                    view: view,
                    disabled: disabled
                })
            ]
        })
    }, props));
};
SearchShips.defaultProps = {
    error: undefined,
    actions: null,
    ships: []
};

;// CONCATENATED MODULE: ./components/ShipsPage/ShipsSearch/components/SearchShips/index.js


// EXTERNAL MODULE: ./components/ShipsPage/ShipsSearch/components/SearchDeck/searchDeck.module.sass
var searchDeck_module = __webpack_require__(86702);
var searchDeck_module_default = /*#__PURE__*/__webpack_require__.n(searchDeck_module);
;// CONCATENATED MODULE: ./components/ShipsPage/ShipsSearch/components/SearchDeck/SearchDeck.jsx








var SearchDeck = function(_param) /*#__PURE__*/ {
    var value = _param.value, id = _param.id, placeholder = _param.placeholder, label = _param.label, error = _param.error, loading = _param.loading, disabled = _param.disabled, view = _param.view, deck = _param.deck, firstLoading = _param.firstLoading, props = (0,_object_without_properties/* default */.Z)(_param, [
        "value",
        "id",
        "placeholder",
        "label",
        "error",
        "loading",
        "disabled",
        "view",
        "deck",
        "firstLoading"
    ]);
    return (0,jsx_runtime.jsx)(DropDown/* DropDown */.v, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        firstLoading: firstLoading,
        id: id,
        value: value,
        placeholder: placeholder,
        label: label,
        error: error,
        disabled: disabled,
        view: view
    }, props), {
        content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (searchDeck_module_default()).checkboxes,
            children: deck.map(function(days) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* Checkbox */.X, {
                    name: id,
                    disabled: loading,
                    value: "".concat(days),
                    view: view,
                    children: days
                }, days);
            })
        })
    }));
};
SearchDeck.defaultProps = {
    error: undefined,
    rangeDays: {}
};

;// CONCATENATED MODULE: ./components/ShipsPage/ShipsSearch/components/SearchDeck/index.js


// EXTERNAL MODULE: ./components/SearchCruises/SearchCruises.jsx + 8 modules
var SearchCruises = __webpack_require__(5291);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./components/ShipsPage/SwitchShips/SwitchShips.module.sass
var SwitchShips_module = __webpack_require__(10063);
var SwitchShips_module_default = /*#__PURE__*/__webpack_require__.n(SwitchShips_module);
;// CONCATENATED MODULE: ./components/ShipsPage/SwitchShips/SwitchShips.jsx














var SwitchShips = (0,es/* observer */.Pi)(function(_param) {
    var className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className"
    ]);
    var setFieldValue = (0,formik_esm/* useFormikContext */.u6)().setFieldValue;
    var store = (0,RootStoreProvider/* useShipsSearchStore */.rm)();
    var router = (0,next_router.useRouter)();
    var handleChange = function(value) {
        return function() {
            store.clearFilters();
            setFieldValue(props.name, value);
            store.getList(value);
        };
    };
    var updateResult = function(value) {
        setFieldValue(props.name, value);
        store.getList(value);
    };
    (0,react.useEffect)(function() {
        var type = router.query.type;
        type === "sea" ? updateResult(SearchCruises/* CruiseType.Sea */.s.Sea) : updateResult(SearchCruises/* CruiseType.Rivers */.s.Rivers);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: (0,classcat/* default */.Z)([
            (SwitchShips_module_default()).switchShips,
            (0,_define_property/* default */.Z)({}, className, !!className)
        ])
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (SwitchShips_module_default()).wrap,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    className: (0,classcat/* default */.Z)([
                        (0,_define_property/* default */.Z)({}, (SwitchShips_module_default()).active, SearchCruises/* CruiseType.Rivers */.s.Rivers === props.value),
                        (SwitchShips_module_default()).button, 
                    ]),
                    onClick: function() {
                        handleChange(SearchCruises/* CruiseType.Rivers */.s.Rivers)();
                        (0,YaAndGaHelper/* YaAndGaShipPage */.tj)("click_rivers");
                    },
                    type: "button",
                    children: "Речные"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    className: (0,classcat/* default */.Z)([
                        (0,_define_property/* default */.Z)({}, (SwitchShips_module_default()).active, SearchCruises/* CruiseType.Sea */.s.Sea === props.value),
                        (SwitchShips_module_default()).button, 
                    ]),
                    onClick: function() {
                        handleChange(SearchCruises/* CruiseType.Sea */.s.Sea)();
                        (0,YaAndGaHelper/* YaAndGaShipPage */.tj)("click_seas");
                    },
                    type: "button",
                    children: "Морские"
                })
            ]
        })
    }));
});

;// CONCATENATED MODULE: ./components/ShipsPage/SwitchShips/index.js


;// CONCATENATED MODULE: ./components/ShipsPage/ShipsSearch/ShipsSearch.jsx



















var AutoSubmitFrom = (0,es/* observer */.Pi)(function() {
    var store = (0,RootStoreProvider/* useShipsSearchStore */.rm)();
    var setFilters = function(filters) {
        return store.setFilters(filters);
    };
    // const clearFilters = () => store.clearFilters();
    var ref = (0,formik_esm/* useFormikContext */.u6)(), values = ref.values, submitForm = ref.submitForm, setFieldValue = ref.setFieldValue;
    (0,react.useEffect)(function() {
        setFilters(values);
        submitForm();
    }, [
        values
    ]);
    var type = values.type;
    (0,react.useEffect)(function() {
        setFieldValue("selectedShips", []);
        setFieldValue("selectedDeck", []);
    }, [
        type
    ]);
    return null;
});
var ShipsSearch = (0,es/* observer */.Pi)(function(_param) {
    var className = _param.className, liners = _param.liners, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className",
        "liners"
    ]);
    var ref;
    var store = (0,RootStoreProvider/* useShipsSearchStore */.rm)();
    var _shipsList = store.shipsList, shipsList = _shipsList === void 0 ? [] : _shipsList, _filterDecks = store.filterDecks, filterDecks = _filterDecks === void 0 ? [] : _filterDecks, isLoading = store.isLoading;
    var filter = function(c, s) {
        store.filterByDecksAndShips(c, s);
    };
    if (isLoading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonCover/* SkeletonCover */.B, {
            width: "100%",
            height: 172,
            backgroundColor: "#FFF",
            className: (shipsSearch_module_default()).skeleton
        });
    }
    var ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: (0,classcat/* default */.Z)([
            (shipsSearch_module_default()).wrapper,
            (0,_define_property/* default */.Z)({}, className, !!className)
        ])
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
            initialValues: {
                selectedDeck: [],
                selectedShips: [],
                type: (ref1 = (ref = store.filters) === null || ref === void 0 ? void 0 : ref.type) !== null && ref1 !== void 0 ? ref1 : SearchCruises/* CruiseType.Rivers */.s.Rivers
            },
            onSubmit: function() {
                var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
                    var selectedDeck, selectedShips;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                selectedDeck = param.selectedDeck, selectedShips = param.selectedShips;
                                filter(selectedDeck, selectedShips);
                            case 2:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }));
                return function(_) {
                    return _ref.apply(this, arguments);
                };
            }(),
            children: function(param) {
                var values = param.values;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(formik_esm/* Form */.l0, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoSubmitFrom, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (shipsSearch_module_default()).titleWrap,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: (shipsSearch_module_default()).title,
                                children: liners ? "Морские лайнеры" : "Речные теплоходы"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (shipsSearch_module_default()).top,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchShips, {
                                    id: "selectedShips",
                                    label: liners ? "Лайнер" : "Теплоход",
                                    ships: shipsList.map(function(ship) {
                                        return ship.name;
                                    }),
                                    value: values.selectedShips,
                                    searchLabel: liners ? "Поиск Лайнера" : "Поиск Теплоход"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchDeck, {
                                    id: "selectedDeck",
                                    label: "Палубность",
                                    deck: filterDecks.map(function(deck) {
                                        return deck.lable;
                                    }).map(String).sort(),
                                    value: values.selectedDeck
                                })
                            ]
                        })
                    ]
                });
            }
        })
    }));
});

;// CONCATENATED MODULE: ./components/ShipsPage/ShipsSearch/index.js


;// CONCATENATED MODULE: ./components/ShipsPage/ShipsPage.jsx








var ShipsPage = function(param) {
    var isMobile = param.isMobile, popdir = param.popdir, isDiscount = param.isDiscount, title = param.title, cashback = param.cashback, isSpecial = param.isSpecial, isVendors = param.isVendors, description = param.description, liners = param.liners;
    var isWide = (0,lib/* useMediaLayout */.EB)("(max-width: 770px)");
    var isMob = (0,lib/* useMediaLayout */.EB)("(max-width: 500px)");
    var getPhoto = function() {
        if (isWide) {
            return "http://kruiz.online/tablet_popdir".concat(popdir.cover_img);
        }
        if (isMob) {
            return "http://kruiz.online/mobile_popdir".concat(popdir.cover_img);
        }
        return "http://kruiz.online/".concat(popdir.cover_img);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: !isDiscount && !isVendors ? popdir && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (shipsPage_module_default()).searchPagePopdir,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (shipsPage_module_default()).ground,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (shipsPage_module_default()).searchPageWrap,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (shipsPage_module_default()).textBannerPopdir,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                bottomGap: 12,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Anchor */.e, {
                                                    variant: "link-2",
                                                    href: "/popdir",
                                                    children: "Популярные направления"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                bottomGap: 42,
                                                variant: "heading-1",
                                                component: "h1",
                                                color: "white",
                                                children: popdir.caption
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                className: (shipsPage_module_default()).textBannerPopdirInside,
                                                variant: "heading-6",
                                                color: "white",
                                                children: description
                                            }),
                                            cashback && cashback
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (shipsPage_module_default()).bannerImg,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: getPhoto(),
                                            alt: "",
                                            loading: "lazy"
                                        })
                                    })
                                ]
                            })
                        })
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (shipsPage_module_default()).discountBanner,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (shipsPage_module_default()).bannerAll,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (shipsPage_module_default()).bannerAllText,
                                children: [
                                    !isMobile && !isVendors && !cashback && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                        variant: "heading-6",
                                        component: "h1",
                                        color: "white",
                                        className: (shipsPage_module_default()).headText,
                                        children: "Все скидки и акции от круизных операторов"
                                    }),
                                    isSpecial && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                        variant: "textShadow-2",
                                        children: "Все актуальные скидки и акции от круизных операторов"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                        variant: isMobile ? "heading-2" : "heading-1",
                                        component: "h1",
                                        color: "white",
                                        className: (shipsPage_module_default()).textBanner,
                                        children: !isVendors ? popdir === null || popdir === void 0 ? void 0 : popdir.caption : "Все речные круизы без наценок. Расписание и стоимость"
                                    }),
                                    cashback && cashback,
                                    (popdir === null || popdir === void 0 ? void 0 : popdir.discount_conditions) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                        variant: "heading-6",
                                        color: "white",
                                        className: (shipsPage_module_default()).discountConditions,
                                        children: popdir.discount_conditions
                                    }),
                                    title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                        color: "white",
                                        children: "*цены указаны без учета скидки"
                                    }),
                                    (popdir === null || popdir === void 0 ? void 0 : popdir.vendor_promotions) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                                            color: "white",
                                            variant: "textShadow-2",
                                            children: [
                                                "Выбирайте круизы с выгодой до 50%!",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                " Суммируются акции \xabЛучшее предложение дня\xbb",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                " до 30% и \xabКэшбэк 20%\xbb"
                                            ]
                                        })
                                    })
                                ]
                            }),
                            !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (shipsPage_module_default()).bannerImg,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "http://kruiz.online/".concat(popdir === null || popdir === void 0 ? void 0 : popdir.cover_img),
                                    alt: "",
                                    loading: "lazy"
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: !isMobile ? (shipsPage_module_default()).search : null,
                children: isClient/* isClient */.C && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShipsSearch, {
                        liners: liners
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShipSearchResults, {
                liners: liners,
                popdir: popdir,
                isMobile: isMobile
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/ShipsPage/index.js



/***/ }),

/***/ 61273:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* reexport */ SkeletonCard; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-content-loader/dist/react-content-loader.es.js
var react_content_loader_es = __webpack_require__(24561);
// EXTERNAL MODULE: ./components/Skeleton/Skeleton.module.sass
var Skeleton_module = __webpack_require__(36701);
var Skeleton_module_default = /*#__PURE__*/__webpack_require__.n(Skeleton_module);
;// CONCATENATED MODULE: ./components/Skeleton/SkeletonCard.jsx







var SkeletonCard = function(_param) /*#__PURE__*/ {
    var animate = _param.animate, props = (0,_object_without_properties/* default */.Z)(_param, [
        "animate"
    ]);
    return (0,jsx_runtime.jsx)("div", {
        className: (Skeleton_module_default()).card,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_content_loader_es/* default */.ZP, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            speed: 1,
            width: 400,
            animate: animate,
            viewBox: "0 0 358 562",
            backgroundColor: "#F3F6F9",
            foregroundColor: "#F9F9F9",
            style: {
                maxWidth: "100%",
                minWidth: "100%"
            }
        }, props), {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    x: "0",
                    y: "8",
                    rx: "0",
                    ry: "0",
                    width: "358",
                    height: "40"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    x: "0",
                    y: "60",
                    rx: "0",
                    ry: "0",
                    width: "358",
                    height: "224"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    x: "8",
                    y: "292",
                    rx: "0",
                    ry: "0",
                    width: "342",
                    height: "20"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    x: "8",
                    y: "316",
                    rx: "0",
                    ry: "0",
                    width: "285",
                    height: "20"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    x: "8",
                    y: "340",
                    rx: "0",
                    ry: "0",
                    width: "260",
                    height: "24"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    x: "8",
                    y: "400",
                    rx: "0",
                    ry: "0",
                    width: "167",
                    height: "24"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    x: "8",
                    y: "370",
                    rx: "0",
                    ry: "0",
                    width: "218",
                    height: "24"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    x: "8",
                    y: "430",
                    rx: "0",
                    ry: "0",
                    width: "153",
                    height: "24"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    x: "8",
                    y: "460",
                    rx: "0",
                    ry: "0",
                    width: "342",
                    height: "1"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    x: "8",
                    y: "493",
                    rx: "0",
                    ry: "0",
                    width: "125",
                    height: "24"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    x: "174",
                    y: "476",
                    rx: "4",
                    ry: "4",
                    width: "170",
                    height: "56"
                })
            ]
        }))
    });
};

;// CONCATENATED MODULE: ./components/Skeleton/index.js



/***/ }),

/***/ 46902:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "T": function() { return /* reexport */ SortPopup; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-use/esm/useClickAway.js
var useClickAway = __webpack_require__(69293);
// EXTERNAL MODULE: ./node_modules/classcat/index.js
var classcat = __webpack_require__(83840);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82580);
// EXTERNAL MODULE: ./components/SortPopup/sortpopup.module.sass
var sortpopup_module = __webpack_require__(8758);
var sortpopup_module_default = /*#__PURE__*/__webpack_require__.n(sortpopup_module);
// EXTERNAL MODULE: ./components/Icon/index.js + 1 modules
var Icon = __webpack_require__(85708);
// EXTERNAL MODULE: ./components/SpriteSVG/index.ts + 1 modules
var SpriteSVG = __webpack_require__(2708);
;// CONCATENATED MODULE: ./components/SortPopup/SortPopup.jsx









var SortPopup = function(param) {
    var id = param.id, url = param.url, sorts = param.sorts, active = param.active, actionOnChange = param.actionOnChange;
    var ref;
    var setFieldValue = (0,formik_esm/* useFormikContext */.u6)().setFieldValue;
    var ref1 = (0,react.useState)(false), isOpen = ref1[0], setIsOpen = ref1[1];
    var activeIndex = sorts.findIndex(function(i) {
        return active.sort_mode === i.mode && active.sort_direction === i.type;
    });
    var ref2 = (0,react.useRef)();
    (0,useClickAway/* default */.Z)(ref2, function() {
        if (isOpen) setIsOpen(false);
    });
    var onChoose = function(choice) {
        actionOnChange === null || actionOnChange === void 0 ? void 0 : actionOnChange();
        setFieldValue(id, choice);
        setIsOpen(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (sortpopup_module_default()).wrapper,
        ref: ref2,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                className: url === "black_friday" ? (sortpopup_module_default()).btnBf : (sortpopup_module_default()).btn,
                onClick: function() {
                    return setIsOpen(!isOpen);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: (ref = sorts[activeIndex]) === null || ref === void 0 ? void 0 : ref.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SpriteSVG/* IconSVG */.u, {
                                name: url === "black_friday" ? "common/sort-arrowsBf" : "common/sort-arrows",
                                width: 16,
                                height: 16
                            })
                        })
                    })
                ]
            }),
            isOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: url === "black_friday" ? (sortpopup_module_default()).listBf : (sortpopup_module_default()).list,
                children: sorts && sorts.length && sorts.map(function(param, index) {
                    var title = param.title, mode = param.mode, type = param.type;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            type: "button",
                            className: (0,classcat/* default */.Z)((0,_define_property/* default */.Z)({}, url === "black_friday" ? (sortpopup_module_default()).activeBf : (sortpopup_module_default()).active, index === activeIndex)),
                            onClick: function() {
                                return onChoose({
                                    sort_mode: mode,
                                    sort_direction: type
                                });
                            },
                            children: title
                        })
                    }, title);
                })
            })
        ]
    });
};
SortPopup.defaultProps = {
    sorts: []
};

;// CONCATENATED MODULE: ./components/SortPopup/index.js



/***/ }),

/***/ 38264:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"accordion":"accordion_accordion__Ww9nJ","accordionTitle":"accordion_accordionTitle__M2XG2","innerTitle":"accordion_innerTitle__wJIwd","accordionContent":"accordion_accordionContent__pVsW5","accordionContentActive":"accordion_accordionContentActive__Lnz13","close":"accordion_close__jwAf8","open":"accordion_open__FTLja"};

/***/ }),

/***/ 75685:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"breadCrumbs_wrapper__GujyW","overflowWrapper":"breadCrumbs_overflowWrapper__O0aFR","point":"breadCrumbs_point___AwGt","current":"breadCrumbs_current__uks0O","currentBf":"breadCrumbs_currentBf__aXcqk","active":"breadCrumbs_active__ExqTi","activeBf":"breadCrumbs_activeBf__8B_QV","crumb":"breadCrumbs_crumb__8cnCn","home":"breadCrumbs_home__ahfAn","homeBf":"breadCrumbs_homeBf__oorFp"};

/***/ }),

/***/ 75949:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"emptySearch":"emptySearch_emptySearch__bZYoo","emptySearchIcon":"emptySearch_emptySearchIcon__MJDnD","emptySearchDescription":"emptySearch_emptySearchDescription__dD2Df"};

/***/ }),

/***/ 74249:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"shipCard_wrapper__aHN5G","percent":"shipCard_percent__3RqUr","footerPrice":"shipCard_footerPrice__TX_iX","shipButton":"shipCard_shipButton__QsmJn","main":"shipCard_main___AlUj","header":"shipCard_header__yFSon","favorite":"shipCard_favorite__rLHjl","pic":"shipCard_pic__L9_mG","company":"shipCard_company__esttE","blackout":"shipCard_blackout__OUsiH","badges":"shipCard_badges__j37lu","dots":"shipCard_dots__GZJvM","dot":"shipCard_dot__Yn_Rc","active":"shipCard_active__aPRHD","morePhotos":"shipCard_morePhotos__ZKh7A","embla":"shipCard_embla__c09ns","emblaContainer":"shipCard_emblaContainer__JILJ0","emblaSlide":"shipCard_emblaSlide__Bvmla","zones":"shipCard_zones__jJ9GK","zone":"shipCard_zone__EHmFZ","viewed":"shipCard_viewed__YbYj5","body":"shipCard_body__VdqOy","time":"shipCard_time__Q83d3","year":"shipCard_year___s7iq","bonus":"shipCard_bonus__7BLqp","footer":"shipCard_footer__g8oli","price":"shipCard_price__spozj","oldPrice":"shipCard_oldPrice__KkO3d","btn":"shipCard_btn__oMFss","btnRent":"shipCard_btnRent___pQee"};

/***/ }),

/***/ 19079:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"cardList":"shipCardList_cardList__vxg9t"};

/***/ }),

/***/ 54972:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"shipDesktopResult_wrapper__8JO_w","list":"shipDesktopResult_list__skHLZ","search":"shipDesktopResult_search__anQQH","header":"shipDesktopResult_header__cVjPA","total":"shipDesktopResult_total__XHYU0","sidebar":"shipDesktopResult_sidebar__8l9zf","sidebarHeader":"shipDesktopResult_sidebarHeader__JVpcZ","sidebarTop":"shipDesktopResult_sidebarTop__W80Ek","sidebarTitle":"shipDesktopResult_sidebarTitle__ArRad","skeletonCover":"shipDesktopResult_skeletonCover__KcXdG","applyFilter":"shipDesktopResult_applyFilter__tLHqC","sidebarOpen":"shipDesktopResult_sidebarOpen__YF2Na","sort":"shipDesktopResult_sort__RuPgN"};

/***/ }),

/***/ 8978:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"header":"shipFilterCheckboxes_header__0El0k","title":"shipFilterCheckboxes_title__sQFlF","body":"shipFilterCheckboxes_body__Bgc4y","item":"shipFilterCheckboxes_item__9D_i4","info":"shipFilterCheckboxes_info__3GDMx","count":"shipFilterCheckboxes_count__WVNJ2","footer":"shipFilterCheckboxes_footer__4OXh_"};

/***/ }),

/***/ 99590:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"shipMobileResult_wrapper__4BdK3","buttonWrapper":"shipMobileResult_buttonWrapper__NifOx","list":"shipMobileResult_list__cjE0B","search":"shipMobileResult_search__LL3Z_","header":"shipMobileResult_header__e8e5G","total":"shipMobileResult_total__XZRsk","sidebar":"shipMobileResult_sidebar__ygIeL","sidebarHeader":"shipMobileResult_sidebarHeader__QZHZV","applyFilter":"shipMobileResult_applyFilter__TKOuO","applyFilterMargin":"shipMobileResult_applyFilterMargin__Y9CW7","hide":"shipMobileResult_hide__rwsMq","sort":"shipMobileResult_sort__0Bqwr"};

/***/ }),

/***/ 86702:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"checkboxes":"searchDeck_checkboxes__YqS_a","element":"searchDeck_element__izvtq"};

/***/ }),

/***/ 78141:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"searchCityActions":"searchShips_searchCityActions__Op843"};

/***/ }),

/***/ 50172:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"shipsSearch_skeleton__rZElB","titleWrap":"shipsSearch_titleWrap__1EWZv","title":"shipsSearch_title__O2eO_","top":"shipsSearch_top__IqCT0","btn":"shipsSearch_btn__F102k","actions":"shipsSearch_actions__jV32x","relative":"shipsSearch_relative__Pp8Ce","calendar":"shipsSearch_calendar__u_XCj","active":"shipsSearch_active__ERgu6"};

/***/ }),

/***/ 10063:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"switchShips":"SwitchShips_switchShips__PDNXZ","wrap":"SwitchShips_wrap__r_CXq","button":"SwitchShips_button__qvA3P","active":"SwitchShips_active__1fLQl"};

/***/ }),

/***/ 17766:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"searchPagePopdir":"shipsPage_searchPagePopdir__eQBIi","searchPageWrap":"shipsPage_searchPageWrap__pvzB8","search":"shipsPage_search__PHFNO","bannerImg":"shipsPage_bannerImg__hgInu","discountConditions":"shipsPage_discountConditions__kBBPC","textBanner":"shipsPage_textBanner___Mk6z","headText":"shipsPage_headText__ls96d","textBannerPopdir":"shipsPage_textBannerPopdir__AIC5A","textBannerPopdirInside":"shipsPage_textBannerPopdirInside__Ca3As","bannerAll":"shipsPage_bannerAll__nc3QR","bannerAllText":"shipsPage_bannerAllText__MgqL0","discountBanner":"shipsPage_discountBanner__UPIn9"};

/***/ }),

/***/ 36701:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"card":"Skeleton_card__UKdC1","selectCabin":"Skeleton_selectCabin__aFpe_"};

/***/ }),

/***/ 8758:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"sortpopup_wrapper__D1XUw","btn":"sortpopup_btn__9GAN0","btnBf":"sortpopup_btnBf__z_bQm","list":"sortpopup_list__IzZow","listBf":"sortpopup_listBf__BeuEs","active":"sortpopup_active__LERZc","activeBf":"sortpopup_activeBf__9DvOy"};

/***/ }),

/***/ 30587:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
exports.EB = __webpack_unused_export__ = __webpack_unused_export__ = void 0;
var useMedia_1 = __webpack_require__(88038);
__webpack_unused_export__ = ({ enumerable: true, get: function () { return useMedia_1.default; } });
__webpack_unused_export__ = ({ enumerable: true, get: function () { return useMedia_1.useMedia; } });
Object.defineProperty(exports, "EB", ({ enumerable: true, get: function () { return useMedia_1.useMediaLayout; } }));


/***/ }),

/***/ 88038:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useMediaLayout = exports.useMedia = exports.mockMediaQueryList = void 0;
var react_1 = __webpack_require__(67294);
var utilities_1 = __webpack_require__(51654);
exports.mockMediaQueryList = {
    media: '',
    matches: false,
    onchange: utilities_1.noop,
    addListener: utilities_1.noop,
    removeListener: utilities_1.noop,
    addEventListener: utilities_1.noop,
    removeEventListener: utilities_1.noop,
    dispatchEvent: function (_) { return true; },
};
var createUseMedia = function (effect) { return function (rawQuery, defaultState) {
    if (defaultState === void 0) { defaultState = false; }
    var _a = react_1.useState(defaultState), state = _a[0], setState = _a[1];
    var query = utilities_1.queryObjectToString(rawQuery);
    effect(function () {
        var mounted = true;
        var mediaQueryList = typeof window === 'undefined'
            ? exports.mockMediaQueryList
            : window.matchMedia(query);
        var onChange = function () {
            if (!mounted) {
                return;
            }
            setState(Boolean(mediaQueryList.matches));
        };
        mediaQueryList.addListener(onChange);
        setState(mediaQueryList.matches);
        return function () {
            mounted = false;
            mediaQueryList.removeListener(onChange);
        };
    }, [query]);
    return state;
}; };
exports.useMedia = createUseMedia(react_1.useEffect);
exports.useMediaLayout = createUseMedia(react_1.useLayoutEffect);
exports["default"] = exports.useMedia;


/***/ }),

/***/ 26426:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
function camelToHyphen(camelString) {
    return camelString
        .replace(/[A-Z]/g, function (string) { return "-" + string.toLowerCase(); })
        .toLowerCase();
}
exports["default"] = camelToHyphen;


/***/ }),

/***/ 51654:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.noop = exports.queryObjectToString = exports.camelToHyphen = void 0;
var camelToHyphen_1 = __webpack_require__(26426);
Object.defineProperty(exports, "camelToHyphen", ({ enumerable: true, get: function () { return camelToHyphen_1.default; } }));
var queryObjectToString_1 = __webpack_require__(71168);
Object.defineProperty(exports, "queryObjectToString", ({ enumerable: true, get: function () { return queryObjectToString_1.default; } }));
var noop_1 = __webpack_require__(98419);
Object.defineProperty(exports, "noop", ({ enumerable: true, get: function () { return noop_1.default; } }));


/***/ }),

/***/ 98419:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
function noop() { }
exports["default"] = noop;


/***/ }),

/***/ 71168:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var camelToHyphen_1 = __webpack_require__(26426);
var QUERY_COMBINATOR = ' and ';
function queryObjectToString(query) {
    if (typeof query === 'string') {
        return query;
    }
    return Object.entries(query)
        .map(function (_a) {
        var feature = _a[0], value = _a[1];
        var convertedFeature = camelToHyphen_1.default(feature);
        var convertedValue = value;
        if (typeof convertedValue === 'boolean') {
            return convertedValue ? convertedFeature : "not " + convertedFeature;
        }
        if (typeof convertedValue === 'number' &&
            /[height|width]$/.test(convertedFeature)) {
            convertedValue = convertedValue + "px";
        }
        return "(" + convertedFeature + ": " + convertedValue + ")";
    })
        .join(QUERY_COMBINATOR);
}
exports["default"] = queryObjectToString;


/***/ })

}]);